import _ from "lodash";
import { v4 as uuidv4 } from "uuid";

export const DURATION_UNITS = {
  MINUTES: "MINUTES",
  HOURS: "HOURS"
};

export const DEFAULT_PACKAGE = {
  name: null,
  price: null,
  description: null
};

const DEFAULT_SERVICE = {
  name: '',
  description: '',
  displayDuration: null,
  displayDurationUnit: DURATION_UNITS.MINUTES,
  duration: null,
  durationUnit: DURATION_UNITS.MINUTES,
  enabled: true,
  availableForOnlineBookings: true,
  hideDurations: false,
  requiresContact: false,
  requiresContactByEmail: false,
  requiresContactByPhone: false,
  resources: [],
  packages: {},
  packagesDisplayOrder: []
};

export function servicePackage(opts) {
  return {
    ...DEFAULT_PACKAGE,
    ...opts,
    _id: uuidv4()
  };
}

export function service(opts) {
  const basePackage = servicePackage();
  return {
    ..._.cloneDeep(DEFAULT_SERVICE),
    packages: { [basePackage._id]: basePackage },
    packagesDisplayOrder: [basePackage._id],
    ..._.cloneDeep(opts)
  };
}
